import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getNotificationEvent = (notificationTypeId) => {
  let isEventBased = false;
  let isAdhoc = notificationTypeId === 3 ? true : false;
  let isAuto = notificationTypeId === 1 ? true : false;
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_NOTIFICATION_EVENT(
      isEventBased,
      isAdhoc,
      isAuto
    )
  );
};

export default getNotificationEvent;
